import React from 'react';
import {
  Box,
  Container,
  Flex,
  Image,
  List,
  ListItem,
  Text,
} from '@chakra-ui/react';

const AdvanceModule = () => (
  <Container maxW="container.lg">
    <Flex
      padding={{ xs: '50px 0px', md: '100px 50px 35px' }}
      // flexWrap="wrap"
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'center', md: 'start' }}
      // justifyContent={{ md: 'center' }}
      gap="10"
      w="100%"
    >
      <Box>
        <Image
          src="https://static.levocdn.com/WGLBUT82/businessman-shaking-hand-female-coworker-during-company-meeting1-lDi9GcznsfvG.png"
          objectFit="cover"
          w="full"
          h="full"
        />
      </Box>

      <List spacing={3} w={{ xs: '100%', lg: '523.49px' }}>
        <Text
          fontWeight="600"
          fontSize={{ xs: '14px', md: '24px' }}
          lineHeight="150%"
          mb="1rem"
          letterSpacing="0.02em"
          color="#010E04"
        >
          The Key Objectives of IVCA GreenReturns Summit:
        </Text>
        <ListItem
          fontSize={{ xs: '14px', md: '18px' }}
          display="flex"
          color="#46564A"
        >
          <Image
            src="https://static.levocdn.com/WGLBUT82/Group7971-SvI2sFrj5o3h.png"
            width="16px"
            height="25px"
            objectFit="contain"
            mr="10px"
          />
          Showcasing climate investment opportunities and fund management in
          India.
        </ListItem>
        <ListItem
          fontSize={{ xs: '14px', md: '18px' }}
          display="flex"
          color="#46564A"
        >
          <Image
            src="https://static.levocdn.com/WGLBUT82/Group7971-SvI2sFrj5o3h.png"
            width="16px"
            height="25px"
            objectFit="contain"
            mr="10px"
          />
          Attracting Global North finance decision-makers to India.
        </ListItem>
        <ListItem
          fontSize={{ xs: '14px', md: '18px' }}
          display="flex"
          color="#46564A"
        >
          <Image
            src="https://static.levocdn.com/WGLBUT82/Group7971-SvI2sFrj5o3h.png"
            width="16px"
            height="25px"
            objectFit="contain"
            mr="10px"
          />
          Fostering engagement among investors, industry leaders, and
          policymakers.
        </ListItem>
        <ListItem
          fontSize={{ xs: '14px', md: '18px' }}
          display="flex"
          color="#46564A"
        >
          <Image
            src="https://static.levocdn.com/WGLBUT82/Group7971-SvI2sFrj5o3h.png"
            width="16px"
            height="25px"
            objectFit="contain"
            mr="10px"
          />
          Facilitating the flow of commercial and impact capital through
          strategic structuring.
        </ListItem>
        <ListItem
          fontSize={{ xs: '14px', md: '18px' }}
          display="flex"
          color="#46564A"
        >
          <Image
            src="https://static.levocdn.com/WGLBUT82/Group7971-SvI2sFrj5o3h.png"
            width="16px"
            height="25px"
            objectFit="contain"
            mr="10px"
          />
          Creating commercial frameworks for climate adaptation and resilience.
        </ListItem>
      </List>
    </Flex>
    <Text
      fontWeight="400"
      fontSize={{ xs: '14px', md: '18px' }}
      lineHeight="150%"
      letterSpacing="0.02em"
      color="#46564A"
      ml={{ xs: '10px', md: '40px' }}
      mb="50px"
    >
      The summit will feature in-depth discussions on policy, investments,
      regulations, and technological aspects of climate change investing in
      India. Innovations in financial, regulatory, and business processes will
      be explored to drive impactful solutions suited to the needs of the global
      South.
    </Text>
  </Container>
);

export default AdvanceModule;
